
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from "@/components/ui/card";
import { Speaker } from '@/integrations/supabase/client';
import { Button } from "@/components/ui/button";

interface SpeakerCardProps {
  speaker: Speaker;
  isMobile: boolean;
  index?: number;
}

const microsoftLogoUrl = "/__l5e/assets-v1/d41d5129-6151-4e52-b09d-54cac2fb08c6/speaker-logo-microsoft-cropped.png";
const oracleLogoUrl = "/__l5e/assets-v1/6ed4a92c-5c82-480b-815e-0061386530a2/speaker-logo-oracle-cropped.png";

const getCompanyLogo = (speaker: Speaker) => {
  const companyName = speaker.company_name?.toLowerCase() || '';

  if (companyName.includes('microsoft')) return microsoftLogoUrl;
  if (companyName.includes('oracle')) return oracleLogoUrl;

  return speaker.company_logo;
};

const SpeakerCard = ({ speaker, isMobile, index = 0 }: SpeakerCardProps) => {
  const companyLogo = getCompanyLogo(speaker);
  // Check if this is Akis Papageorgiou's card
  const isAkis = speaker.name.toLowerCase().includes('akis papageorgiou');
  
  // Check if this is WEKA (Liran's card)
  const isWeka = speaker.company_name?.toLowerCase().includes('weka');
  
  // Check if this is BCG (Puneet's card)
  const isBCG = speaker.company_name?.toLowerCase().includes('bcg');
  
  // Check if this is AmpiFire (Jay's card)
  const isAmpiFire = speaker.company_name?.toLowerCase().includes('ampifire');
  
  return (
    <Link 
      to={`/speakers/${speaker.slug || speaker.name.toLowerCase().replace(/\s+/g, '-')}`}
      className="block animate-scale-in"
      style={{ 
        animationDelay: `${index * 150}ms`
      }}
    >
      <Card className="bg-white border-blue-300/20 shadow-md overflow-hidden hover:transform hover:scale-105 transition-all duration-300 relative">
        <div className={`relative ${isMobile ? 'h-40' : 'h-60'} overflow-hidden flex items-center justify-center`}>
          <img 
            src={speaker.image_url} 
            alt={speaker.name} 
            className={`w-full h-full ${isMobile ? 'object-contain' : (isAkis ? 'object-cover object-[center_15%]' : 'object-cover')}`}
          />
        </div>
        <CardContent className="p-4 relative">
          <h4 className="text-sm font-bold text-blue-900 mb-1 text-left">{speaker.name}</h4>
          <p className="text-xs text-blue-700 mb-2 text-left">{speaker.title}</p>
          
          <div 
            className="h-11 w-full bg-white border border-white rounded-md flex items-center pl-2"
            title={`${speaker.company_name} logo`}
          >
            {companyLogo ? (
              <img 
                src={companyLogo} 
                alt={`${speaker.company_name} logo`}
                className={`${isWeka ? 'max-h-16 max-w-full' : isBCG ? 'max-h-10 max-w-full' : isAmpiFire ? 'max-h-16 max-w-full' : 'max-h-9 max-w-[75%]'} object-contain`}
              />
            ) : (
              <span className="text-blue-500 text-sm">{speaker.company_name}</span>
            )}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default SpeakerCard;
